const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.specification_approvals/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.specification_approvals/LIST_SPECIFICATION_APPROVALS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
